import { useTranslation } from 'react-i18next';
import React, { FC } from 'react';
import { Details, Heading, Paragraph } from '@digdir/designsystemet-react';

import { EnergyPlan } from '../../../../../types/building';
import { UserInput } from '../../../../../types/registration/userInput';
import { StyledDetailsContent } from '../../samtykke/form/components/styledComponents';

import { MerkeArealView } from './merkeAreal';
import { NettoEnergiBehovView } from './nettoenergibehov';
import { LevertEnergiOgVektetView } from './levertenergi';
import { LokaltklimaView } from './lokaltklima';

interface SummaryResultProps {
  energiplan: EnergyPlan;
  userInput: UserInput;
}

export const SummaryResult: FC<SummaryResultProps> = ({ energiplan, userInput }) => {
  const { t } = useTranslation();

  const utdata = energiplan.energimerke?.utdata;
  const totalBRA = userInput.bygningsdetaljer?.totalBRA;
  const totalOppvarmetBRA = userInput.bygningsdetaljer?.totalOppvarmetBRA;

  if (!utdata?.energiforbruk) {
    return null;
  }

  return (
    <Details>
      <Details.Summary>{t('expertToolsJSON.summary.resultat.title')}</Details.Summary>
      <StyledDetailsContent>
        <Heading level={6} data-size="2xs">
          {t('register.summary.result.description_1')}
        </Heading>
        <Paragraph data-size="sm">{t('register.summary.result.description_2')}</Paragraph>
      </StyledDetailsContent>
      <StyledDetailsContent>
        <MerkeArealView
          energiKarakter={energiplan.energimerke?.energiKarakter}
          totalBRA={totalBRA}
          totalOppvarmetBRA={totalOppvarmetBRA}
        />
        <NettoEnergiBehovView energiforbruk={utdata.energiforbruk} totalOppvarmetBRA={totalOppvarmetBRA} />
        <LevertEnergiOgVektetView
          totalOppvarmetBRA={totalOppvarmetBRA}
          energiplan={energiplan}
          energiforbruk={utdata.energiforbruk}
        />
        {utdata.energiforbrukILokaltKlima && (
          <LokaltklimaView
            energiforbrukILokaltKlima={utdata.energiforbrukILokaltKlima}
            totalOppvarmetBRA={totalOppvarmetBRA}
          />
        )}
      </StyledDetailsContent>
    </Details>
  );
};
